import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Http } from '@angular/http';
import { ParentService } from '../A2-utils/ParentClass/ParentService';
import { Router } from '@angular/router';
import { constant } from 'app/app.constants';

@Injectable()
export class ProvidersBillingService extends ParentService {
  ReloadGridUnprocess$ = new EventEmitter<boolean>();
  private companyId = new BehaviorSubject<number>(null);
  companyId$ = this.companyId.asObservable();

  constructor(private http: Http, private route: Router) {
    super()
    this.verifyToken(this.http, route);
   }

  getIncompleteTrips(providerid): Observable<any> {
    return this.http.get(constant.URL_GET_INCOMPLETE_TRIPS + providerid, this.getHeader())
           .map(res => res.json())
           .catch((error: any) => this.validate401Error(error, this.route))
  }

  getTripsReadyToBill(providerid): Observable<any> {
    return this.http.get(constant.URL_GET_TRIPS_READY_TO_BILL + providerid, this.getHeader())
           .map(res => res.json())
           .catch((error: any) => this.validate401Error(error, this.route))
  }

  submitTrips(data): Observable<any> {
    const bodyString = JSON.stringify(data);
    return this.http.put(constant.URL_GET_SUBMIT_TRIPS, bodyString, this.headerPost())
           .map(res => res.json())
           .catch((error: any) => this.validate401Error(error, this.route))
  }

  validTripsBeforeSubmit(data: any): Observable<any> {
    const bodyString = JSON.stringify(data);
    return this.http.put(constant.URL_GET_VALIDATE_SUBMIT_TRIPS, bodyString, this.headerPost())
           .map(res => res.json())
           .catch((error: any) => this.validate401Error(error, this.route));
  }

  /**
   * this get batch list
   * @param providerid
   */
  getBatchs(providerid) {
    return this.http.get(constant.URL_GET_CLAIM_BATCH_BY_PROVIDER + providerid, this.getHeader())
           .map(res => res.json())
           .catch((error: any) => this.validate401Error(error, this.route))
  }

  /**
   * this get batch details
   * @param batchid
   */
  getBatchDetails(batchid) {
    return this.http.get(constant.URL_GET_CLAIM_BATCH_DETAIL_BY_PROVIDER + batchid, this.getHeader())
           .map(res => res.json())
           .catch((error: any) => this.validate401Error(error, this.route))
  }

   /**
   * this get batch list
   * @param providerid
   */
  getPaidBatchs(providerid) {
    return this.http.post(constant.URL_GET_PAID_BATCH + providerid, undefined, this.headerPost())
           .map(res => res.json())
           .catch((error: any) => this.validate401Error(error, this.route))
  }

  /**
   * this get paid batch details
   * @param batchid
   */
  getPaidBatchDetails(batchid, providerid?) {
    return this.http.get(constant.URL_GET_PAID_BATCH_DETAIL + providerid + `/${batchid}`, this.getHeader())
           .map(res => res.json())
           .catch((error: any) => this.validate401Error(error, this.route))
  }

  getBatchClaimReport(batchid) {
    return this.http.get(`${constant.URL_GET_CLAIM_BATCH_REPORT}${batchid}`, this.getFileHeaders())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getEopBatchReport(companyid, batchid, isExcel) {
    return this.http
      .get(
        `${constant.URL_GET_EOP_BATCH_REPORT}${companyid}/PaymentBatchId/${batchid}?isExcel=${isExcel}`,
        this.getFileHeaders()
      )
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error));
  }


  getPaymentDenied(providerid) {
      return this.http.get(constant.URL_GET_PAYMENT_DENIED + providerid, this.getHeader())
           .map(res => res.json())
           .catch((error: any) => this.validate401Error(error, this.route))
  }

  setCompanyId(companyId: number) {
    this.companyId.next(companyId);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/providers-billing/providers-billing-service.service.ts